/**
 * Taglines shown on the login screen, header, and PWA splash.
 * Domain: a Google Keep clone — quick notes, sticky-note feel, friendly.
 */

export const TAGLINES: readonly string[] = [
  "Sticky notes that follow you everywhere.",
  "Your second brain, lightly toasted.",
  "Like a fridge magnet that syncs.",
  "Where ideas wait politely.",
  "Markdown for the impatient.",
  "Now with 100% more pinning.",
  "We promise not to lose this one.",
  "Index cards, but lazier.",
  "Cookies and reminders, fresh out of the oven.",
  "Forget less, do more.",
  "Tiny thoughts, tidy storage.",
  "A drawer for your brain crumbs.",
  "Yes, with mermaid diagrams. Of course.",
  "Bullet points are a love language.",
  "Tasks, but with feelings.",
  "Notes that don't curl at the edges.",
  "Drafts welcome.",
  "It's like Pinboard, but warmer.",
  "Today's thought, tomorrow's epiphany.",
  "All your sticky thoughts in one drawer.",
  "Color-coded chaos, lovingly indexed.",
  "Procrastination, now with markdown.",
  "Type fast, think slow.",
  "Save the post-it, save the day.",
  "Where shower thoughts go to grow up.",
  "It does, in fact, support task lists.",
  "Press save, breathe out.",
  "Memorable, except for the parts you forgot.",
  "A friend for your runaway ideas.",
  "Loose thoughts welcome, all colors served.",
  "Powered by sticky-note physics.",
  "Less paper. Same crinkly feeling.",
  "Your fridge, but tidy.",
  "Drafts, todos, doodles — same drawer.",
  "Press the yellow button. You'll see.",
  "Tag it, color it, find it.",
  "Reminder: there is a reminders feature.",
  "Built with caffeine and Cloudflare.",
  "All edge, no edges.",
  "Hot takes go in the yellow folder.",
  "Don't lose the grocery list this time.",
  "A clipboard for your brain.",
  "Pocket-sized productivity.",
  "Forget? Not on our watch.",
  "Type now, sort later.",
  "Your future self will thank you.",
  "Index, search, sigh in relief.",
  "Hold ideas like glitter.",
  "Now, where did I put that — oh, there it is.",
  "Markdown is also a love language.",
  "Outline mode: chaotic good.",
  "Notes that won't stick to your shoes.",
  "Searchable. Shareable. Loveable.",
  "Yes, you can pin that.",
  "Mermaid said it. We rendered it.",
  "Less than 1MB of feelings.",
  "Backed up before you finish typing.",
  "Tap a color. Feel a feeling.",
  "Notes by the millisecond.",
  "Hold my todos.",
  "Idea drift, neatly catalogued.",
  "Quick capture for slow thinkers.",
  "Sticky notes, but online.",
  "Wallpaper for your brain.",
  "What if Trello and Notion had a tiny baby.",
  "Yes, share that. With one person. Or none.",
  "Less swiping, more saving.",
  "Mermaid diagrams, even on iPhone.",
  "It's almost embarrassingly fast.",
  "Refrigerator door, but cross-platform.",
  "Bookmark the unbookmarkable.",
  "We tested it. A lot. Probably too much.",
  "Where 'I'll remember this' goes to actually be remembered.",
  "Reminds you so you don't have to.",
  "AI helps you write. You take the credit.",
  "Simplify with a click. Or two clicks. We don't judge.",
  "OpenAI key optional, brain required.",
  "Markdown is the new lined paper.",
  "Press cmd-K. Find joy.",
  "Search like you mean it.",
  "Notes-keeping for the easily distracted.",
  "Now starring: your thoughts.",
  "Calmly archives your chaos.",
  "Press ⌘ + N. Be free.",
  "Pin it like you mean it.",
  "All thoughts welcome, no commitment.",
  "Where exclamation points belong.",
  "Doodle? Sure. Diagram? Yes.",
  "Sticky-note vibes, real persistence.",
  "Reminder: hydrate. Also, this app.",
  "Yes, dark mode. Of course dark mode.",
  "Capture today, recall tomorrow.",
  "Your favorite drawer, but searchable.",
  "Color is a feature, not a vibe.",
  "Sometimes you just need a yellow square.",
  "Indexing happily since today.",
  "Imagine remembering everything. We can dream.",
  "Snippets of you, neatly aligned.",
  "Three colors and a checklist makes a kingdom.",
  "Save it, share it, sleep better.",
  "Backed up by the edge.",
  "Notes for whoever you'll be tomorrow.",
  "Friendly fire-and-forget storage.",
  "An app with a clear conscience.",
  "Memoization, but for life.",
  "Better than that one yellow notebook.",
  "Hand-drawn vibes, machine-fast search.",
  "Notes, beautifully boring.",
  "Yes, install us. We're tiny.",
  "Markdown rendered before you blink.",
  "All thoughts persisted, none judged.",
  "Recipes? Yes. Secrets? Encrypted.",
  "Now with R/W shares for the brave.",
  "Saved in the cloud, kept on the edge.",
  "Synced before you sync.",
  "Procrastination loves company. Pin it.",
  "Less paper, more keeping.",
  "Pinned to the top of your day.",
  "Where small wins live big.",
  "Three pins, one folder, infinite chaos averted.",
  "Captured at 3am. Read at 9am.",
  "Notes that actually load.",
  "Catch ideas before they bolt.",
  "A drawer that never gets full.",
  "Press space. Take a breath.",
  "It's just notes. But, you know, better.",
  "Productivity, served on a yellow square.",
  "Markdown so smooth you'll forget it's text.",
  "Now with reminders. You're welcome.",
  "Searchable, shareable, snackable.",
  "Snap a photo. Pin a thought.",
  "Auto-formatted, manually appreciated.",
  "Yes, it works offline. Probably.",
  "Tiny, fast, friendly.",
  "Where the lists live.",
  "Markdown for the rest of us.",
  "Built for thumbs.",
  "Add to home screen. Forget what worry feels like.",
  "Hello, future self. Here are your notes.",
  "Notes-keeping, but make it edge.",
  "Drafts welcome. Polish optional.",
  "Save a thought. Save a moment.",
  "If it sticks, it ships.",
  "Faster than your last text message.",
  "Made for sloppy thinkers.",
  "All thoughts considered.",
  "Reflexively saved.",
  "Notes app, no notes.",
  "More notes, fewer notes-apps.",
  "Less app, more help.",
  "Yes, dark mode. Yes, light mode. Yes, system.",
  "We took 'keep' and ran with it.",
  "From inbox zero to ideas zero.",
  "Press save. Walk away. We've got it.",
  "Like a clipboard, but it remembers you.",
  "Reflections of the cleverest version of you.",
  "Outliving Post-its since forever.",
  "Find anything in one keystroke.",
  "Notes that don't fade in the sun.",
  "Your back pocket, with backups.",
  "Yellow is a personality.",
  "Take a note. Take five.",
  "Now with bottom toolbars. Native vibes.",
  "Built for the home screen.",
  "Notes that wait their turn.",
  "Edit anywhere. Read everywhere.",
  "Optimized for the moment you forget.",
  "A pocket. A drawer. A second brain.",
  "Less inbox, more outbox.",
  "Two-tap pins, three-tap folders.",
  "It's all in your notes now.",
  "Brought to you by 1MB of feelings.",
  "Edge-powered, brain-friendly.",
  "Yes, you can fix your typos with one click.",
  "AI assist, only if you want.",
  "Like Notion, but it loads.",
  "Like Evernote, but it's still here.",
  "Goes well with coffee and lists.",
  "Where the drafts feel safe.",
  "All your todos, served warm.",
  "Pocket-sized brain backup.",
  "Yes, your notes survive a power outage.",
  "Built fast for fast thinkers.",
  "Notes that come back when you call them.",
  "One drawer to rule them all.",
  "Yes, your share links are random.",
  "Securely random, friendly to click.",
  "Reminders that respect your dnd.",
  "Yes, you can print them. We don't recommend it.",
  "Powered by tiny yellow squares.",
  "Indexes love this one weird trick.",
  "Drag, drop, done.",
  "Tap a folder. Find a friend.",
  "Backups: not a worry.",
  "Markdown, mermaid, magic.",
  "Notes for the always-on.",
  "Sticky-note physics, no glue.",
  "A keep, not a hoard.",
  "Quietly remembered, brilliantly retrieved.",
];

/** Return a random tagline. Stable for a given seed when provided. */
export function randomTagline(seed?: number): string {
  if (seed === undefined) {
    return TAGLINES[Math.floor(Math.random() * TAGLINES.length)];
  }
  return TAGLINES[seed % TAGLINES.length];
}
